import { useEffect } from "react";
import { motion } from "framer-motion";
import { ChevronLeft, ChevronRight, MessageCircle, X } from "lucide-react";
import { buildWaLink, imgSrc } from "../lib/api";

export const Lightbox = ({ product, whatsapp, onClose, onPrev, onNext }) => {
    useEffect(() => {
        const onKey = (e) => {
            if (e.key === "Escape") onClose();
            if (e.key === "ArrowLeft") onPrev();
            if (e.key === "ArrowRight") onNext();
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [onClose, onPrev, onNext]);

    return (
        <motion.div
            data-testid="lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/85 backdrop-blur-xl p-4"
        >
            <button
                data-testid="lightbox-close"
                onClick={onClose}
                aria-label="Fechar"
                className="absolute top-4 right-4 z-10 flex h-11 w-11 items-center justify-center border border-[#27272A] bg-[#0B0B0B]/80 text-white transition-colors hover:border-[#FF6A00] hover:text-[#FF6A00]"
            >
                <X size={20} />
            </button>
            <button
                data-testid="lightbox-prev"
                onClick={(e) => {
                    e.stopPropagation();
                    onPrev();
                }}
                aria-label="Anterior"
                className="absolute left-3 sm:left-6 z-10 flex h-11 w-11 items-center justify-center border border-[#27272A] bg-[#0B0B0B]/80 text-white transition-colors hover:border-[#FF6A00] hover:text-[#FF6A00]"
            >
                <ChevronLeft size={22} />
            </button>
            <motion.img
                key={product.id}
                data-testid="lightbox-image"
                src={imgSrc(product.image_url)}
                alt=""
                onClick={(e) => e.stopPropagation()}
                initial={{ scale: 0.92, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ type: "spring", stiffness: 260, damping: 24 }}
                className="max-h-[75vh] max-w-full object-contain border border-[#27272A]"
            />
            <button
                data-testid="lightbox-next"
                onClick={(e) => {
                    e.stopPropagation();
                    onNext();
                }}
                aria-label="Próxima"
                className="absolute right-3 sm:right-6 z-10 flex h-11 w-11 items-center justify-center border border-[#27272A] bg-[#0B0B0B]/80 text-white transition-colors hover:border-[#FF6A00] hover:text-[#FF6A00]"
            >
                <ChevronRight size={22} />
            </button>
            {whatsapp && (
                <a
                    data-testid="whatsapp-order-button"
                    href={buildWaLink(whatsapp, product.ref)}
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => e.stopPropagation()}
                    className="absolute bottom-5 sm:bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-3 bg-[#FF6A00] px-7 sm:px-9 py-4 font-condensed font-bold uppercase tracking-widest text-base sm:text-lg text-black transition-colors hover:bg-[#FF8533]"
                >
                    <MessageCircle size={20} strokeWidth={2.5} />
                    Pedir pelo WhatsApp
                </a>
            )}
        </motion.div>
    );
};
